import { Directive, Input, EventEmitter, Output, ElementRef, HostListener, inject } from '@angular/core';

@Directive({ selector: '[appScrollSpy]' })
export class ScrollSpyDirective {
  private _el = inject(ElementRef);

  @Input() public spiedTags = [];

  // Sometimes borders and such can cause things to be come misaligned,
  // so a little leeway can help here
  @Input() public scrollPadding = 1;

  @Output() public sectionChange = new EventEmitter<string>();

  private currentSection: string;

  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    let currentSection: string;
    const children = this._el.nativeElement.children;
    const scrollTop = event.target.scrollTop;
    const parentOffset = event.target.offsetTop;
    for (const element of children) {
      if (this.spiedTags.some(spiedTag => spiedTag === element.tagName)) {
        if (element.offsetTop - parentOffset <= scrollTop + this.scrollPadding) {
          currentSection = element.id;
        }
      }
    }
    if (currentSection !== this.currentSection) {
      this.currentSection = currentSection;
      this.sectionChange.emit(this.currentSection);
    }
  }
}
